// extracted by mini-css-extract-plugin
export default {"root":"src_root__+meUV","app":"src_app__6LyV9"};